import { IDeliveryCoordinates } from 'src/app/common/models/deliveryCoordinates.interface';
import { MovPolygon } from '../../../../common/models/movPolygon';

export const DeliveryMapChangeKinds = {
  Standard: 'standard',
  Extended: 'extended',
  ExtendedEnabled: 'extended-enabled',
  MovAll: 'mov-all',
  MovUpdated: 'mov-updated',
} as const;

export type DeliveryMapChangeKind = (typeof DeliveryMapChangeKinds)[keyof typeof DeliveryMapChangeKinds];

export interface StandardChange {
  kind: typeof DeliveryMapChangeKinds.Standard;
  coordinates: IDeliveryCoordinates[];
}

export interface ExtendedChange {
  kind: typeof DeliveryMapChangeKinds.Extended;
  coordinates: IDeliveryCoordinates[];
}

export interface ExtendedEnabledChange {
  kind: typeof DeliveryMapChangeKinds.ExtendedEnabled;
  enabled: boolean;
}

export interface MovAllChange {
  kind: typeof DeliveryMapChangeKinds.MovAll;
  movPolygons: MovPolygon[];
}

export interface MovUpdatedChange {
  kind: typeof DeliveryMapChangeKinds.MovUpdated;
  name: string;
  polygon: MovPolygon;
}

export type DeliveryMapChangeEvent =
  StandardChange | ExtendedChange | ExtendedEnabledChange | MovAllChange | MovUpdatedChange;
